import { Navigate, Outlet, useLocation } from 'react-router';
import { useSession } from '@/lib/auth/useSession';

/** Signed-in area: without a session, go to the login page and come back after. */
export function RequireSession() {
  const s = useSession();
  const location = useLocation();
  if (!s) {
    const next = location.pathname + location.search;
    return <Navigate to={next === '/' ? '/login' : `/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <Outlet />;
}
